const mathRandom = function () {
  try {
    const crypto = window.crypto || window.msCrypto
    let array = new Uint32Array(1)
    let max = Math.pow(2, 32)
    return crypto.getRandomValues(array)[0] / max
  } catch (e) {
    return Math.random()
  }
}

const isHexColor = value => {
  const REGEX = /^#?(?:[a-f\d]{3}){1,2}$/iu

  return REGEX.test(value)
}
//change background color hex values to shaded alpha vals
const addAlphaValToHexColor = (color, opacity = 1) => {
  let theColor = '#ffffff'
  if (isHexColor(color)) {
    theColor = color
  }
  const opac = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
  return theColor + opac.toString(16).toUpperCase()
}

// Returns a random integer between min (inclusive) and max (inclusive).
const getRandomInt = (min, max) => {
  return Math.floor(mathRandom() * (Math.floor(max) - Math.ceil(min) + 1)) + min
}

const randomuuidv4 = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (mathRandom() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

//Filter an array of objects to unique only.
const unique = arr => {
  return arr.reduce((acc, item) => {
    if (!acc.includes(item)) {
      acc.push(item)
    }
    return acc
  }, [])
}

const getRandomString = function (length) {
  var result = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(mathRandom() * charactersLength))
  }
  return result
}

export {
  unique,
  getRandomInt,
  getRandomString,
  randomuuidv4,
  addAlphaValToHexColor,
  isHexColor,
}
